var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRingBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 625307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.26141 21.9777C9.512 23.4391 10.7696 24.4995 12.2517 24.4995C13.7341 24.4995 14.9921 23.4391 15.2427 21.9777L15.258 21.8887H9.24609L9.26141 21.9777Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.482 17.7998C22.2367 17.5544 21.9867 17.347 21.7449 17.1461C20.728 16.3016 19.8496 15.5724 19.8496 12.5443V10.1425C19.8496 6.61065 17.3682 3.51159 13.9347 2.73457C14.0723 2.46469 14.1421 2.18103 14.1421 1.88975C14.1421 0.847834 13.2942 0 12.2519 0C11.2099 0 10.3622 0.847834 10.3622 1.88975C10.3622 2.18122 10.4318 2.46483 10.5695 2.73457C7.13596 3.51159 4.65461 6.61065 4.65461 10.1425V12.5443C4.65461 15.5724 3.77625 16.3017 2.75931 17.1461C2.51756 17.3469 2.26759 17.5544 2.0223 17.7998L2 17.8221V20.205H22.5042V17.8221L22.482 17.7998Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 209",
    cx: 19.252,
    cy: 6.25,
    r: 5.75,
    fill: "#EC3811",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRingBadge);
export default __webpack_public_path__ + "static/media/icon_ring_badge.f582ff78cfab575dde47cddf3d724d17.svg";
export { ForwardRef as ReactComponent };